module.exports = __webpack_public_path__ + "static/media/about-us-1.1a017cc5.png";